import React, { Fragment } from 'react'
import {
  View,
  SpacerVertical,
  Frame,
  Typography,
  Stepper
} from '@klarna/bubble-ui'
import { Node } from '../../types'
import getValueFromNodes from '../../utilities/getValueFromNode'
import TimelineHeading from './TimelineHeading'
import CheckoutTimeline from '../CheckoutTimeline/CheckoutTimeline'

type PaymentStepsTimelineProps = {
  nodes: Node[]
  frameBackground?: string
  titleToken?: string
  headerToken?: string
  paragraphColorToken?: string
  bulletsToken?: string
};

const PaymentStepsTimeline: React.FC<PaymentStepsTimelineProps> = ({
  nodes,
  frameBackground = 'colors/backgrounds/default',
  titleToken = 'text-style/text/labels/tall/bold',
  headerToken = '',
  paragraphColorToken = 'colors/text/default'
}) => {
  const entries = [1, 2, 3].map(v => {
    const paragraphProperty = nodes.some(node => node.name.includes('TIMELINE'))
      ? `TIMELINE_STEP${v}_PARAGRAPH`
      : `CHECKOUT_INFO${v}_PARAGRAPH`
    return ({
      title: <TimelineHeading step={v} nodes={nodes} textToken={headerToken} />,
      description: getValueFromNodes(nodes, paragraphProperty),
    })
  })

  const titleProperty = nodes.some(node => node.name.includes('TIMELINE')) ? 'TIMELINE_TITLE' : 'CHECKOUT_INFO_TITLE'

  return (
    <Fragment>
      <Typography
        accessibilityPreset='heading 3'
        textToken={titleToken}
        textAlignToken="text-alignment/start"
      >
        {getValueFromNodes(nodes, titleProperty)}
      </Typography>
      <Frame backgroundColorToken={frameBackground} paddingToken={'space.0'}>
        <View>
          <SpacerVertical spaceToken="space.200" />
          {titleProperty.includes('TIMELINE')
            ? <Stepper>
              {entries.map((entry, index) => (
              // @ts-ignore
                <Stepper.Item key={index} title={entry.title}
                  description={
                    <Typography
                      colorToken={paragraphColorToken}
                    >{entry.description}</Typography>}/>
              ))}
            </Stepper>
            : <CheckoutTimeline entries={entries} />
          }
        </View>
        <SpacerVertical spaceToken="space.200" />
      </Frame>
    </Fragment>
  )
}

export default PaymentStepsTimeline
